import React, { useState } from 'react';
import { ArrowForward } from '@mui/icons-material';
import { cn } from 'src/utils/utility';

interface TourCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  onClick?: () => void;
  // We accept these but might override or use them differently for the premium look
  gradientClass?: string;
  iconBgClass?: string;
  blurColor?: string;
  // New prop for accent color to tint the icon bg/text if needed
  accentColor?: string;
}

export const TourCard: React.FC<TourCardProps> = ({
  title,
  description,
  icon,
  onClick,
  blurColor,
  iconBgClass = 'bg-green-10', // Default light green
}) => {
  const [isHovered, setIsHovered] = useState(false);
  // Extract hex color from blurColor (e.g., "bg-[#00992B]" -> "#00992B")
  const extractedColor = blurColor?.match(/#[A-Fa-f0-9]{6}/)?.[0];

  return (
    <button
      type='button'
      onClick={onClick}
      className='relative p-12 rounded-8 border border-neutral-20 bg-white shadow-light hover:shadow-custom transition-all cursor-pointer group relative overflow-hidden h-full text-left w-full'
      onMouseEnter={(e) => {
        setIsHovered(true);
        if (extractedColor) {
          e.currentTarget.style.borderColor = extractedColor;
        }
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        e.currentTarget.style.borderColor = '';
      }}
    >
      <div className='w-full flex items-center gap-16'>
        <div className={`flex-shrink-0 w-40 h-40 flex items-center justify-center rounded-8 transition-colors ${iconBgClass}`}>{icon}</div>
        <div className='flex-grow z-10 min-w-0'>
          <h3 className='text-16 font-bold text-neutral-80 truncate'>{title}</h3>
          <p className='text-14 text-neutral-50 line-clamp-2 leading-relaxed truncate'>{description}</p>
        </div>

        <div className='flex-shrink-0 text-neutral-70 transition-all z-10' style={{ color: isHovered && extractedColor ? extractedColor : undefined }}>
          <ArrowForward fontSize='small' sx={{ fontSize: 20 }} />
        </div>
      </div>
      {blurColor && <div className={cn('w-[90px] h-[90px] rounded-full blur-[45px] absolute top-[-85px] right-[-43px]', blurColor)} />}
    </button>
  );
};
